var map = {
	"./essential-oil.json": [
		1167,
		[
			167
		]
	],
	"./herbal-seeds.json": [
		2279,
		[
			279
		]
	],
	"./herbs-powder.json": [
		1332,
		[
			332
		]
	],
	"./herbs.json": [
		2210,
		[
			210
		]
	],
	"./oil-seeds.json": [
		9353,
		[
			353
		]
	],
	"./spices.json": [
		4937,
		[
			937
		]
	],
	"./super-foods.json": [
		2661,
		[
			661
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4025;
module.exports = webpackAsyncContext;